"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const charts_1 = require("@amcharts/amcharts4/charts");
const am4core = require("@amcharts/amcharts4/core");
const core_1 = require("@amcharts/amcharts4/core");
const animated_1 = require("@amcharts/amcharts4/themes/animated");
const core_2 = require("@angular/core");
const label_format_1 = require("../../../views/chart/speedometer-chart/shared/label-format");
const chart_base_control_1 = require("../chart-base.control");
const speedometer_chart_control_options_model_1 = require("../shared/speedometer-chart-control-options.model");
let SpeedometerChartControlComponent = class SpeedometerChartControlComponent extends chart_base_control_1.ChartBaseControl {
    constructor(ngZone) {
        super();
        this.ngZone = ngZone;
        /**
         * The index of the gauge that will be rendered.
         * @type {number}
         */
        this.selectedCategoryIndex = 0;
        this.hands = [];
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.initChart();
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            this.chart.dispose();
        });
    }
    initChart() {
        this.chart = am4core.create(this.chartContainerElement.nativeElement, charts_1.GaugeChart);
        this.chartTitle = this.chart.titles.create();
        this.chartTitle.text = this.data.categories[this.selectedCategoryIndex];
        this.createAxes();
        this.setChartOptions();
        this.configureChartDefaults();
        this.createHands();
        this.setLegendData();
    }
    createAxes() {
        const axis = this.chart.xAxes.push(new charts_1.ValueAxis());
        axis.min = this.chartOptions.lowerBound;
        axis.max = this.chartOptions.upperBound;
        axis.strictMinMax = true;
        axis.renderer.minGridDistance = 100;
        axis.renderer.radius = am4core.percent(90);
        axis.renderer.inside = true;
        axis.renderer.line.strokeOpacity = 0.1;
        axis.renderer.ticks.template.disabled = false;
        axis.renderer.ticks.template.strokeOpacity = 1;
        axis.renderer.ticks.template.strokeWidth = 0.5;
        axis.renderer.ticks.template.length = 15;
        axis.renderer.labels.template.adapter.add('radius', (radius, target) => {
            const valueLength = target.dataItem.values.value.value.toString().length;
            if (valueLength <= 5) {
                return am4core.percent(25);
            }
            if (valueLength <= 7) {
                return am4core.percent(35);
            }
            return am4core.percent(45);
        });
        axis.renderer.labels.template.fontSize = "0.9em";
        axis.renderer.labels.template.truncate = true;
        axis.renderer.labels.template.maxWidth = 60;
        this.axis = this.chart.xAxes.push(new charts_1.ValueAxis());
        this.axis.min = this.chartOptions.lowerBound;
        this.axis.max = this.chartOptions.upperBound;
        this.axis.strictMinMax = true;
        this.axis.renderer.labels.template.disabled = true;
        this.axis.renderer.ticks.template.disabled = true;
        this.axis.renderer.grid.template.disabled = true;
    }
    configureChartDefaults() {
        am4core.useTheme(animated_1.default);
        this.chart.innerRadius = am4core.percent(90);
        this.chart.startAngle = -210;
        this.chart.endAngle = 30;
        this.chart.resizable = true;
    }
    setChartOptions() {
        if (this.chartOptions) {
            this.createRanges();
            this.setLegendDefaultOptions();
            this.setResponsiveDefaultOptions();
            this.setRTLDefaultOptions();
            if (this.chartOptions.labelFormat === label_format_1.LabelFormat.PERCENT) {
                this.chart.numberFormatter.numberFormat = "#,###.##'%'";
            }
            else {
                this.chart.numberFormatter.numberFormat = "#,###.##";
            }
        }
    }
    createRanges() {
        this.chartOptions.scaleRanges.forEach((scaleRange) => {
            const range = this.axis.axisRanges.create();
            range.value = scaleRange.from;
            range.endValue = scaleRange.to;
            range.axisFill.fillOpacity = 1;
            range.axisFill.fill = am4core.color(scaleRange.color);
        });
    }
    createHands(isAnimated = false) {
        this.data.series
            .forEach((seriesItem, index) => {
            const value = seriesItem.data[this.selectedCategoryIndex];
            let hand;
            if (this.hands[index]) {
                hand = this.hands[index];
            }
            else {
                hand = this.chart.hands.push(new charts_1.ClockHand());
                this.hands.push(hand);
                hand.fill = am4core.color(this.chartOptions.chartPalette[index]);
                hand.stroke = am4core.color(this.chartOptions.chartPalette[index]);
                hand.startWidth = 8;
                hand.pin.radius = 10;
                hand.zIndex = -1;
                hand.tooltip = new core_1.Tooltip();
                hand.tooltipText = "{value}";
                hand.tooltip.label.interactionsEnabled = true;
                hand.tooltip.keepTargetHover = true;
                hand.tooltip.getFillFromObject = false;
                hand.tooltip.background.fill = am4core.color("#fff");
                hand.tooltip.background.width = 320;
                hand.adapter.add('tooltipHTML', () => {
                    let tooltipTemplate = '<div class="rc-column-tooltip">';
                    tooltipTemplate +=
                        `<div class="rc-speedometer-tooltip">
                                <div class="rc-speedometer-tooltip__title">
                                    ${this.data.categories[this.selectedCategoryIndex]}
                                </div>
                                <div class="rc-speedometer-tooltip__property">
                                    <div class="rc-speedometer-tooltip__text">${seriesItem.name}</div>
                                    <div class="rc-speedometer-tooltip__value">{value}</div>
                                </div>
                            </div>`;
                    return tooltipTemplate;
                });
            }
            if (value !== null && value <= this.chartOptions.upperBound && value >= this.chartOptions.lowerBound) {
                hand.setVisibility(true);
                isAnimated ? hand.showValue(value, 1000, am4core.ease.cubicOut) : hand.showValue(value);
            }
            else {
                hand.setVisibility(false);
            }
        });
    }
    setLegendData() {
        this.chart.legend.data = this.data.series
            .map((seriesItem, index) => {
            return {
                name: seriesItem.name,
                fill: this.chartOptions.chartPalette[index]
            };
        });
    }
    setRTLDefaultOptions() {
        if (this.chartOptions.isRTL) {
            // Set RTL for labels
            this.chart.rtl = true;
            // Change the order of the items in legend, so that first item starts on the right
            this.chart.legend.reverseOrder = true;
            // Flip legend
            this.chart.legend.itemContainers.template.reverseOrder = true;
        }
    }
    setResponsiveDefaultOptions() {
        // Responsive Options
        this.chart.responsive.enabled = true;
    }
    changeSelectedCategoryItem(selectedCategoryIndex) {
        this.selectedCategoryIndex = selectedCategoryIndex;
        this.createHands(true);
        this.chartTitle.text = this.data.categories[this.selectedCategoryIndex];
    }
};
__decorate([
    core_2.Input(),
    __metadata("design:type", String)
], SpeedometerChartControlComponent.prototype, "id", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", speedometer_chart_control_options_model_1.SpeedometerChartControlOptions)
], SpeedometerChartControlComponent.prototype, "chartOptions", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", Object)
], SpeedometerChartControlComponent.prototype, "data", void 0);
__decorate([
    core_2.ViewChild('chartContainer'),
    __metadata("design:type", core_2.ElementRef)
], SpeedometerChartControlComponent.prototype, "chartContainerElement", void 0);
SpeedometerChartControlComponent = __decorate([
    core_2.Component({
        
        selector: "sis-speedometer-chart-control",
        styles: [require('./sis-speedometer-chart-control.component.css')],
        template: require('./sis-speedometer-chart-control.component.html')
    }),
    __metadata("design:paramtypes", [core_2.NgZone])
], SpeedometerChartControlComponent);
exports.SpeedometerChartControlComponent = SpeedometerChartControlComponent;
//# sourceMappingURL=sis-speedometer-chart-control.component.js.map